// extracted by mini-css-extract-plugin
export default {"b-icon-warning":"CaptureVisa_style_b-icon-warning__moi3I","wrapper":"CaptureVisa_style_wrapper__88m1+","rotate":"CaptureVisa_style_rotate__UEf1p"};